import { Close as CloseIcon } from '@mui/icons-material';
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material';
import React from 'react';

import { RelationStatus } from '../../../../types/businessRelations';

interface StatusInfoDialogProps {
  open: boolean;
  onClose: () => void;
}

const StatusInfoDialog: React.FC<StatusInfoDialogProps> = ({
  open,
  onClose,
}) => {
  const statusConfig = [
    {
      status: RelationStatus.ACTIVE,
      color: '#3bc14a',
      label: 'Conectadas',
      description:
        'Empresas actualmente conectadas al SII y en correcto funcionamiento.',
    },
    {
      status: RelationStatus.INACTIVE,
      color: '#FFD93D',
      label: 'No Conectadas',
      description:
        'Empresas sin conexión previa al SII, con posibilidad de activación.',
    },
    {
      status: RelationStatus.DEACTIVATED,
      color: '#EF7722',
      label: 'Desconectadas',
      description:
        'Empresas desconectadas del SII por modificación de credenciales, con posibilidad de activación.',
    },
    {
      status: RelationStatus.SUSPENDED,
      color: '#d32f2f',
      label: 'Por Eliminar',
      description:
        'Empresas con cancelación efectiva al cierre de ciclo, que mantendrán acceso al servicio hasta fin de mes y serán eliminadas automáticamente.',
    },
    {
      status: RelationStatus.DELETED,
      color: '#C9CDCF',
      label: 'Eliminadas',
      description:
        'Empresas eliminadas del sistema por el usuario o automáticamente al cierre de ciclo.',
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
        }}
      >
        <Typography variant="h6" component="div">
          Estados de las Empresas
        </Typography>
        <Button
          onClick={onClose}
          sx={{ minWidth: 'auto', p: 1 }}
          aria-label="Cerrar"
        >
          <CloseIcon />
        </Button>
      </DialogTitle>

      <DialogContent sx={{ pt: 2, pb: 2 }}>
        <Grid container spacing={3}>
          {statusConfig.map((config) => (
            <Grid item xs={12} sm={6} key={config.status}>
              <Box
                sx={{
                  p: 3,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  minHeight: 120,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Chip
                    label={config.label}
                    variant="filled"
                    size="small"
                    sx={{
                      backgroundColor: config.color,
                      color: 'white',
                      fontWeight: 500,
                      '&:hover': {
                        backgroundColor: config.color,
                        opacity: 0.9,
                      },
                    }}
                  />
                </Box>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    lineHeight: 1.6,
                    flex: 1,
                  }}
                >
                  {config.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default StatusInfoDialog;
